import { Box, Card, CardContent, Skeleton } from '@mui/material'

export default function HeaterCardLoading() {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Logo skeleton */}
          <Skeleton variant="rectangular" width={50} height={50} sx={{ borderRadius: 1 }} />

          {/* Name & Ticker skeleton */}
          <Box sx={{ flex: 1 }}>
            <Skeleton width="70%" height={24} />
            <Skeleton width="40%" height={20} />
          </Box>

          {/* Gain skeleton */}
          <Skeleton width={60} height={24} />
        </Box>

        {/* Sector badge skeleton */}
        <Box sx={{ mt: 1 }}>
          <Skeleton width={80} height={24} sx={{ borderRadius: 4 }} />
        </Box>
      </CardContent>
    </Card>
  )
}
